module.exports = __webpack_public_path__ + "static/122-080c7dcb31ce2ba443456e290d62f799.png";